import axios from "axios";

const emailService = axios.create({
    baseURL: process.env.VUE_APP_SUPPORT + "/email",
    timeout: 30000,
    withCredentials: true
});
emailService.defaults.headers['Product'] = 'vsp';

emailService.interceptors.request.use(res => {
    res.headers["token"] = JSON.parse(localStorage.getItem("USER")) ? JSON.parse(localStorage.getItem("USER")).token : '';
    return res;
})

emailService.interceptors.response.use(
    response => {
        if (response.data.errCode === 1) {
            window.$vm.$Message.error(response.data.errMsg);
            return Promise.reject(response.data);
        }

        return response.data;
    },

    error => {
        const code = error.errMsg;
        switch (code) {
            case 401:
                break;
            case 500:
                break;
        }
        return Promise.reject(error);
    }
);

export default {
    SendCode(email) {
        return emailService.post(`/sendCode`, {
            receiver: email,
            product: "vsp"
        });
    },

};